import PropTypes from "prop-types";
import React, { useEffect, useState, useMemo } from "react";
import {
  Container,
  Row,
  Col,
} from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";

import { useParams } from "react-router-dom"

import { UserContext } from "../../../UserContext";
import axios from 'axios'

import {
  OrderId,
  BillingName,
} from "../../Dashboard/LatestTranactionCol";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import UserSingleTable from "pages/Dashboard/UserSingleTable";
function PendingCryptoLTVUserLoans() {

  const [tableData, setTableData] = React.useState([]);
  const { auth, user } = React.useContext(UserContext)
  const [title, setTitle] = React.useState('Pending Crypto LTV Loans');

  const [transactions, setTransactions] = React.useState([]);


  const columns = useMemo(
    () => [
      {
        Header: "Userid",
        accessor: "userid",
        filterable: true,
        disableFilters: true,
        Cell: cellProps => {
          return <OrderId {...cellProps} />;
        },
      },
      {
        Header: "Collateral Currency",
        accessor: "collat_coin",
        disableFilters: true,
        Cell: cellProps => {
          return <OrderId {...cellProps} />;
        },

      },
      {
        Header: "Loan Coin",
        accessor: "loan_coin",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => {
          return <BillingName {...cellProps} />;
        },
      },
      {
        Header: "Payment Amount",
        accessor: "initial_amount",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => {
          return <BillingName {...cellProps} />;
        },
      },
      {
        Header: "Loan Amount",
        accessor: "loan_amount",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => {
          return <BillingName {...cellProps} />;
        },
      },

      {
        Header: "Collateral Percentage",
        accessor: "collateral_percentage",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => {
          // return <PaymentMethod {...cellProps} />;
          return <BillingName {...cellProps} />;
        }

      },
      {
        Header: "Date",
        accessor: "createdAt",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => {
          return <BillingName {...cellProps} />;
        },
      },
      {
        Header: "Action",
        accessor: "id",
        disableFilters: true,
        Cell: cellProps => {
          return (
            <div>
              <button className="btn btn-rounded btn-success" onClick={(e) => { approveDeposit(cellProps.value) }}
              >Approve </button>
              <button className="btn btn-rounded btn-danger" onClick={(e) => { declineDeposit(cellProps.value) }}
              >Decline </button>
            </div>
          );
        },
      },

    ],
    []
  );

  let { userid } = useParams()

  React.useEffect(() => {

    if (auth != null) {
      if (!auth) {
        window.location.href = "/login"
      } else {

        getPendingUserLoans()

      }
    }
  }, [auth])


  const approveDeposit = async (id) => {

    var depositObj = {
      id: id,
      status: '1'
    }

    await axios.post(process.env.REACT_APP_BASE + "api/approve-crypto-ltv-loan-by-id", depositObj).then(async (res) => {
      setTimeout(() => { window.location.reload(); }, 200);
      //await getPendingUserLoans()


    });
  }

  const declineDeposit = async (id) => {

    var depositObj = {
      id: id,
      status: '2'
    }

    await axios.post(process.env.REACT_APP_BASE + "api/decline-crypto-ltv-loan-by-id", depositObj).then(async (res) => {

      if (res.data.status === 200)
        await getPendingUserLoans()
      else
        setTransactions([])

    });
  }

  const getPendingUserLoans = async () => {

    await axios.get(process.env.REACT_APP_BASE + "api/pending-crypto-ltv-loans").then(async (res) => {
      console.log(res.data)
      if (res.data.status === 200)
        setTransactions(res.data.loans)
      else
        setTransactions([])

    });
  }

  return (
    <React.Fragment>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="LTV Loans" breadcrumbItem="LTV Loans" />

          <Row>
            <Col md="12" sm="12">
              <UserSingleTable tableData={transactions} columns={columns} title={title} />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default PendingCryptoLTVUserLoans